// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c8cd5e2e] .v-list-item--disabled {\n  opacity: 0.5;\n}", ""]);
// Exports
module.exports = exports;
